import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isAuthenticated, getUserRole } from '../utils/auth';

/**
 * Component that redirects users to their appropriate dashboard
 * based on their role when they try to access incompatible pages
 */
const RoleBasedRedirect = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAuth = isAuthenticated();
    const userRole = getUserRole();

    useEffect(() => {
        if (!isAuth) return; // Not logged in, allow access to public pages

        const currentPath = location.pathname;

        // Define user-specific pages (pages that only regular users should access)
        const userPages = ['/', '/book', '/search', '/nearby', '/turf/', '/quick-turf/'];
        const isUserPage = userPages.some(page => currentPath === page || currentPath.startsWith(page));

        // Define owner-specific pages
        const isOwnerPage = currentPath.startsWith('/owner') && !currentPath.includes('/login');

        // Define admin-specific pages
        const isAdminPage = currentPath.startsWith('/admin') && !currentPath.includes('/login');

        // Redirect logic based on role
        if (userRole === 'user') {
            // Regular user trying to access owner/admin pages -> redirect to home
            if (isOwnerPage || isAdminPage) {
                navigate('/', { replace: true });
            }
        } else if (userRole === 'owner') {
            // Owner trying to access admin pages -> redirect to owner dashboard
            if (isAdminPage) {
                navigate('/owner', { replace: true });
            }
        } else if (userRole === 'admin') {
            // Admin trying to access owner pages -> redirect to admin dashboard
            if (isOwnerPage) {
                navigate('/admin', { replace: true });
            }
        }
    }, [isAuth, userRole, location.pathname, navigate]);

    return children;
};

export default RoleBasedRedirect;
